import { createContext, useContext, useMemo, useState, type ReactNode } from 'react';

interface SimulationsBreadcrumbContextValue {
  runLabel: string | null;
  setRunLabel: (label: string | null) => void;
}

const SimulationsBreadcrumbContext = createContext<SimulationsBreadcrumbContextValue>({
  runLabel: null,
  setRunLabel: () => {},
});

export const useSimulationsBreadcrumb = () => useContext(SimulationsBreadcrumbContext);

export const SimulationsBreadcrumbProvider = ({ children }: { children: ReactNode }) => {
  const [runLabel, setRunLabel] = useState<string | null>(null);
  const value = useMemo(() => ({ runLabel, setRunLabel }), [runLabel]);
  return (
    <SimulationsBreadcrumbContext.Provider value={value}>
      {children}
    </SimulationsBreadcrumbContext.Provider>
  );
};
